import * as React from 'react';
import cis404 from '../_image/404.svg';
import { makeStyles } from '@mui/styles';
import { WebMeta } from '../_component';
import { Box } from '@mui/material';


const useStyles = makeStyles((theme) => ({
  root: {
    padding: '50px 20px',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: 20,
    },
  },
  box: {
    width: '100%',
    maxWidth: `${theme.maxWidth}px`,
    height: 'calc(100vh - 50px - 240px)',
    backgroundColor: theme.palette.background.paperOpacity,
    borderRadius: theme.borderRadius.large,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 30,
    [theme.breakpoints.down('md')]: {
      marginBottom: 20,
      height: 'calc(100vh - 200px)',
      backgroundColor: theme.palette.background.paper,
    },
    '& .txt': {
      fontSize: 24,
      fontWeight: 500,
      textAlign: 'center',
    },
    '& .btn': {
      paddingBottom: 80,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '&>a>div': {
        padding: '6px 24px',
        color: theme.palette.primary.main,
        fontSize: 14,
        fontWeight: 500,
        borderRadius: '99em',
        border: `1px solid ${theme.palette.line.input}`,
        backgroundColor: theme.palette.background.paper,
        cursor: 'pointer',
        transition: '.3s',
        '&:hover': {
          border: `1px solid ${theme.palette.primary.main}`,
          backgroundColor: theme.palette.background.hover,
        },
      },
    },
    '& .emptyBox': {
      flex: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& img': {
        maxWidth: '100%',
        maxHeight: '100%',
      },
    },
  },
}));


/** 非公司ip頁面 */
export function NotCompany() {

  const classes = useStyles();
  const [webMeta, ] = React.useState({
    url: window.location.href,
    img: '',
    title: '404 找不到頁面',
    description: '客製行程'
  });


  return (
    <>

      <WebMeta data={webMeta}/>

      <Box className={classes.root}>
        <Box className={classes.box}>
          <Box className='emptyBox'>
            <img src={cis404} alt='404' />
          </Box>
          <Box className='txt' pb={20} px={4}>
            <span>
            {
              global.domain.type === 'dev'
              ? '[ 開發站 ] '
              : global.domain.type === 'test'
                ? '[ 測試站 ] '
                : '[ 正式站 ] '
            }
            </span>
            <span>不開放非喜鴻公司內部IP使用</span>
          </Box>
        </Box>
      </Box>

    </>
  )
}